export default function ContactMap() {
  return (
    <div className="bg-background-50 border border-background-200 rounded-lg overflow-hidden">
      <div className="w-full h-72 md:h-80">
        <iframe
          title="白峰美羽品牌地址地图"
          src="https://dlpnnx.cn/maps?q=杭州市西湖区云栖路&output=embed"
          className="w-full h-full border-0"
          loading="eager"
          referrerPolicy="no-referrer-when-downgrade"
        ></iframe>
      </div>
      <div className="p-5">
        <p className="text-sm text-foreground-700 flex items-start gap-2">
          <i className="ri-map-pin-line text-primary-600 mt-0.5"></i>
          浙江省杭州市西湖区云栖路 88 号 白峰美羽品牌中心
        </p>
      </div>
    </div>
  );
}